import React from 'react'

function ProfileActivityPassed() {
  return (
    <div>ProfileActivityPassed</div>
  )
}

export default ProfileActivityPassed